export default "__VITE_ASSET__BkkhdWF6__"